import Model from "./base/model";

class SimulationDestination extends Model {
  resourceName() {
    return "simulation_destinations";
  }

  fields() {
    return {
      state_id: "",
      description: "",
      lead_time: "",
      ad_valorem: "",
      gris: "",
      trt: "",
      tde: "",
      tas: "",
      emex: "",
      toll: "",
      suframa: "",
      river_insurance: "",
      minimum_value_gris: "",
      minimum_value_trt: "",
      minimum_value_tde: "",
      minimum_value_emex: "",
      minimum_value_ad_valorem: "",
      collection_fee: "",
      collection_fee_excess: "",
      collection_fee_excess_kg: "",
      minimum_rate: "",
      minimum_toll: "",
      tub: "",
      dispatch_fee: "",
      re_delivery: "",
      devolution: "",
      insurance: "",
      refaturation: "",
      scheduling: "",
      palletization: "",
      minimum_scheduling: "",
      add_emex: "",
      add_palletization: "",
      tpf: "",
      tlc: "",
      tad: "",
      tda: "",
      chemical_product: "",
      tzr: "",
      confirmation_fee: "",

      state: {jsonApi: "hasOne", type: "states"},

    };
  }
}

export default new SimulationDestination();
